// ebooks-slider.js
import $ from 'jquery';
import 'slick-carousel';
import gsap from 'gsap';

export default function initEbookSlider() {
  $('.ebook-slider-block').each(function () {
    const $block = $(this);
    const $wrap  = $block.find('.eb-wrap');
    const $bar   = $block.find('.eb-progress__bar');
    const $prev  = $block.find('.eb-prev');
    const $next  = $block.find('.eb-next');

    const slideCount = $wrap.find('.eb-slide').length;
    const makeProgress = (idx, total) => {
      if (!$bar.length || total <= 1) return;
      const pct = ((idx + 1) / total) * 100;
      gsap.to($bar.get(0), { width: pct + '%', duration: 0.4, ease: 'power2.out' });
    };

    if (slideCount <= 1) {
      if ($bar.length) gsap.set($bar.get(0), { width: '100%' });
      return;
    }

    $wrap.on('init', (e, slick) => makeProgress(slick.currentSlide, slick.slideCount));
    $wrap.on('afterChange', (e, slick, cur) => makeProgress(cur, slick.slideCount));

    if (!$wrap.hasClass('slick-initialized')) {
      $wrap.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        arrows: true,
        dots: false,
        prevArrow: $prev,
        nextArrow: $next,
        adaptiveHeight: true,
        // optional: swipe, accessibility
        accessibility: true,
        draggable: true,
      });
    } else {
      const slick = $wrap.slick('getSlick');
      makeProgress(slick.currentSlide, slick.slideCount);
    }
  });
}
